import { format } from 'date-fns'
import { format as formatTZ } from 'date-fns-tz'

export function time(time) {
  if (time === '') return
  const alphabet = format(new Date(time), 'yyyy年MM月dd日')
  return alphabet
}

export function deploytime(time) {
  if (time === '') return
  const alphabet = formatTZ(new Date(time), 'yyyyMMdd_HHmmss', {
    timeZone: 'Asia/Tokyo',
  })
  return alphabet
}
